import { render, staticRenderFns } from "./deliveredOrder.vue?vue&type=template&id=879a5e12&scoped=true&"
import script from "./deliveredOrder.vue?vue&type=script&lang=js&"
export * from "./deliveredOrder.vue?vue&type=script&lang=js&"
import style0 from "./deliveredOrder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./deliveredOrder.vue?vue&type=style&index=1&id=879a5e12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879a5e12",
  null
  
)

export default component.exports